import { Modal as ModalModule, Utils } from 'common';
import React from 'react';

const { Modal, ModalButtonActionType } = ModalModule;
const { Session } = Utils;

const SmsTermsModal = ({ modalId }) => {
	const primaryButton = {
		type: ModalButtonActionType.Cancel,
		text: 'Close',
		dataqa: 'sms-terms-close-button',
	};

	const link = 'https://www.stamps.com/conditions/';

	return (
		<Modal
			modalId={modalId}
			className="account-sms-terms"
			header="SMS Messaging Terms"
			primaryButton={primaryButton}
			size="small"
		>
			<p>
				By opting in to SMS messages, you will receive special offers and
				promotions for Stamps.com products, with no more than 4 messages a
				month.
			</p>
			<p>
				You may opt out at any time by replying STOP to any text message. Text
				HELP for help options. SMS is limited to users 18 years of age or older.
			</p>
			<p>
				Service is available on a carrier-by-carrier basis and normal message
				and text rates may apply. Some messages may be provided by an automated
				system. Opt-in is not a condition of purchase.
			</p>
			<p>
				Terms of use available at:{' '}
				<a rel="noopener noreferrer" target="_blank" href={link}>
					{link}
				</a>
			</p>
		</Modal>
	);
};

export default SmsTermsModal;
